export default __webpack_public_path__ + "static/media/maps-white.fdc94102.png";